import { type GradingInstruction } from 'types/GradingInstruction'
import { type SilhouetteInstruction } from 'types/SilhouetteInstruction'

import { mainSplitApi } from './redux/mainSplitApi'

export interface FetchInstructionArgs {
  productCode: string
  channel?: string
  shipTo?: string
  country?: string
}

export const instructionApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchInstruction: builder.query<GradingInstruction, FetchInstructionArgs>({
      query: ({ productCode, channel, shipTo, country }) => {
        const params = new URLSearchParams({ productCode })
        if (channel) params.set('channel', channel)
        if (shipTo) params.set('shipTo', shipTo)
        if (country) params.set('country', country)
        return {
          url: `/instructions/grading?${params.toString()}`,
          method: 'GET'
        }
      }
    }),
    fetchSilhouetteInstruction: builder.query<SilhouetteInstruction | null, string>({
      query: (silhouette) => {
        return {
          url: '/instructions/silhouette',
          method: 'GET',
          params: { silhouette }
        }
      }
    })
  }),
  overrideExisting: false
})

export const { useLazyFetchInstructionQuery, useLazyFetchSilhouetteInstructionQuery } = instructionApi
